module.exports = __webpack_public_path__ + "img/lootbox-epic-5.37e5eb05.jpg";